export default __webpack_public_path__ + "static/media/trr-food-handheld-tunasandwich.340fdeb0.png";